import { createContext, useContext, useEffect } from 'react';
import {
  AddSaveBrokerDto,
  AddressDto,
  ContactDto,
  ReferenceRouteFormDto,
} from '../types';

type ShipFormType = {
  setSelectedATALegsInfo: (selectedATALegsInfo: any) => void;
  setOriginFormData: (originFormData: AddressDto) => void;
  setDestinationFormData: (destinationFormData: AddressDto) => void;
  setShipperFormData: (shipperFormData: ContactDto) => void;
  setConsigneeFormData: (consigneeFormData: ContactDto) => void;
  setCarrierOptionsContext: (carrierOptionsContext: any) => void;
  setRouteValidationsContext: (routeFormValidationContext: any) => void;
  setRatesApiPayloadContext: (ratesApiPayloadContext: any) => void;
  setRatesApiDataContext: (ratesApiDataContext: any) => void;
  setReferenceFormDataContext: (
    referenceFormDataContext: ReferenceRouteFormDto
  ) => void;
  setSpecialInstructionContext: (specialInstructionContext: any) => void;
  setPickupValidateDataContext: (pickupValidateDataContext: any) => void;
  setPickupTimezoneDataContext: (pickupTimezoneDataContext: any) => void;
  setSelectedRateContext: (selectedRateContext: any) => void;
  setFinalRateContext: (finalRateContext: any) => void;
  setPickupPayloadContext: (pickupPayloadContext: any) => void;
  setShippingDocsContext: (shippingDocsContext: any) => void;
  setSelectedServiceContext: (selectedServiveContext: any) => void;
  setSelectedPlanningLaneContext: (selectedPlanningLaneContext: any) => void;
  setSelectedAccountContext: (selectedAccountContext: any) => void;
  setSelectedJobContext: (selectedJobContext: any) => void;
  setSelectedManualLegsContext: (selectedManualLegsContext: any) => void;
  setBrokerFormDataContext: (brokerFormData: AddSaveBrokerDto) => void;
  setIsMetricContext: (isMetricContext: any) => void;
  setSavedQuoteFormDataContext: (savedQuoteFormDataContext: any) => void;
  setAddLegShipmentDataContext: (addLegShipmentDataContext: any) => void;
  setAddLegShipmentPackagesContext: (
    addLegShipmentPackagesContext: any
  ) => void;
  setAllCommoditiesContext: (allCommoditiesContext: any) => void;
  setMultiLegListContext: (multiLegListContext: any) => void;
  setTotalLegsContext: (setTotalLegsContext: any) => void;
  setSelectedMultiLegRateContext: (selectedMultiLegRateContext: any) => void;
  setRatesMultiLegApiDataContext: (ratesMultiLegApiDataContext: any) => void;
};

const ShipFormContext = createContext<ShipFormType | undefined>(undefined);
export function ShipFormProvider({ children }: any) {
  const setOriginFormData = (originFormData: AddressDto) => {
    localStorage.setItem('originFormData', JSON.stringify(originFormData));
  };

  const setSelectedATALegsInfo = (selectedATALegsInfo: any) => {
    localStorage.setItem(
      'selectedATALegsInfo',
      JSON.stringify(selectedATALegsInfo)
    );
  };

  const setDestinationFormData = (destinationFormData: AddressDto) => {
    localStorage.setItem(
      'destinationFormData',
      JSON.stringify(destinationFormData)
    );
  };
  const setShipperFormData = (shipperFormData: ContactDto) => {
    localStorage.setItem('shipperFormData', JSON.stringify(shipperFormData));
  };
  const setConsigneeFormData = (consigneeFormData: ContactDto) => {
    localStorage.setItem(
      'consigneeFormData',
      JSON.stringify(consigneeFormData)
    );
  };
  const setCarrierOptionsContext = (carrierOptionsContext: any) => {
    localStorage.setItem(
      'carrierOptionsContext',
      JSON.stringify(carrierOptionsContext)
    );
  };
  const setRouteValidationsContext = (routeFormValidationContext: any) => {
    localStorage.setItem(
      'routeFormValidationContext',
      JSON.stringify(routeFormValidationContext)
    );
  };
  const setRatesApiDataContext = (ratesApiDataContext: any) => {
    localStorage.setItem(
      'ratesApiDataContext',
      JSON.stringify(ratesApiDataContext)
    );
  };
  const setRatesApiPayloadContext = (ratesApiPayloadContext: any) => {
    localStorage.setItem(
      'ratesApiPayloadContext',
      JSON.stringify(ratesApiPayloadContext)
    );
  };
  const setPickupValidateDataContext = (pickupValidateDataContext: any) => {
    localStorage.setItem(
      'pickupValidateDataContext',
      JSON.stringify(pickupValidateDataContext)
    );
  };
  const setPickupTimezoneDataContext = (pickupTimezoneDataContext: any) => {
    localStorage.setItem(
      'pickupTimezoneDataContext',
      JSON.stringify(pickupTimezoneDataContext)
    );
  };
  const setSelectedRateContext = (selectedRateContext: any) => {
    localStorage.setItem(
      'selectedRateContext',
      JSON.stringify(selectedRateContext)
    );
  };
  const setReferenceFormDataContext = (
    referenceFormDataContext: ReferenceRouteFormDto
  ) => {
    localStorage.setItem(
      'referenceFormDataContext',
      JSON.stringify(referenceFormDataContext)
    );
  };
  const setSpecialInstructionContext = (specialInstructionContext: any) => {
    localStorage.setItem(
      'specialInstructionContext',
      JSON.stringify(specialInstructionContext)
    );
  };
  const setFinalRateContext = (finalRateContext: any) => {
    localStorage.setItem('finalRateContext', JSON.stringify(finalRateContext));
  };
  const setPickupPayloadContext = (pickupPayloadContext: any) => {
    localStorage.setItem(
      'pickupPayloadContext',
      JSON.stringify(pickupPayloadContext)
    );
  };
  const setShippingDocsContext = (shippingDocsContext: any) => {
    localStorage.setItem(
      'shippingDocsContext',
      JSON.stringify(shippingDocsContext)
    );
  };
  const setSelectedServiceContext = (selectedServiceContext: any) => {
    localStorage.setItem(
      'selectedServiceContext',
      JSON.stringify(selectedServiceContext)
    );
  };
  const setSelectedPlanningLaneContext = (selectedPlanningLaneContext: any) => {
    localStorage.setItem(
      'selectedPlanningLaneContext',
      JSON.stringify(selectedPlanningLaneContext)
    );
  };
  const setSelectedAccountContext = (selectedAccountContext: any) => {
    localStorage.setItem(
      'selectedAccountContext',
      JSON.stringify(selectedAccountContext)
    );
  };
  const setSelectedJobContext = (selectedJobContext: any) => {
    localStorage.setItem(
      'selectedJobContext',
      JSON.stringify(selectedJobContext)
    );
  };
  const setSelectedManualLegsContext = (selectedManualLegsContext: any) => {
    localStorage.setItem(
      'selectedManualLegsContext',
      JSON.stringify(selectedManualLegsContext)
    );
  };

  const setBrokerFormDataContext = (brokerFormDataContext: any) => {
    localStorage.setItem(
      'brokerFormDataContext',
      JSON.stringify(brokerFormDataContext)
    );
  };

  const setIsMetricContext = (isMetricContext: any) => {
    localStorage.setItem('isMetricContext', JSON.stringify(isMetricContext));
  };

  const setSavedQuoteFormDataContext = (savedQuoteFormDataContext: any) => {
    localStorage.setItem(
      'savedQuoteFormDataContext',
      JSON.stringify(savedQuoteFormDataContext)
    );
  };

  const setAddLegShipmentDataContext = (addLegShipmentDataContext: any) => {
    localStorage.setItem(
      'addLegShipmentDataContext',
      JSON.stringify(addLegShipmentDataContext)
    );
  };

  const setAddLegShipmentPackagesContext = (
    addLegShipmentPackagesContext: any
  ) => {
    localStorage.setItem(
      'addLegShipmentPackagesContext',
      JSON.stringify(addLegShipmentPackagesContext)
    );
  };

  const setAllCommoditiesContext = (allCommoditiesContext: any) => {
    localStorage.setItem(
      'allCommoditiesContext',
      JSON.stringify(allCommoditiesContext)
    );
  };
  const setMultiLegListContext = (multiLegListContext: any) => {
    localStorage.setItem(
      'multiLegListContext',
      JSON.stringify(multiLegListContext)
    );
  };
  const setTotalLegsContext = (totalLegsContext: any) => {
    localStorage.setItem('totalLegsContext', JSON.stringify(totalLegsContext));
  };
  const setSelectedMultiLegRateContext = (selectedMultiLegRateContext: any) => {
    localStorage.setItem(
      'selectedMultiLegRateContext',
      JSON.stringify(selectedMultiLegRateContext)
    );
  };
  const setRatesMultiLegApiDataContext = (ratesMultiLegApiDataContext: any) => {
    localStorage.setItem(
      'ratesMultiLegApiDataContext',
      JSON.stringify(ratesMultiLegApiDataContext)
    );
  };

  useEffect(() => {
    const handleBeforeUnload = () => {
      localStorage.removeItem('selectedATALegsInfo');
      localStorage.removeItem('originFormData');
      localStorage.removeItem('destinationFormData');
      localStorage.removeItem('shipperFormData');
      localStorage.removeItem('consigneeFormData');
      localStorage.removeItem('carrierOptionsContext');
      localStorage.removeItem('routeFormValidationContext');
      localStorage.removeItem('ratesApiDataContext');
      localStorage.removeItem('ratesApiPayloadContext');
      localStorage.removeItem('referenceFormDataContext');
      localStorage.removeItem('specialInstructionContext');
      localStorage.removeItem('pickupValidateDataContext');
      localStorage.removeItem('pickupTimezoneDataContext');
      localStorage.removeItem('selectedRateContext');
      localStorage.removeItem('finalRateContext');
      localStorage.removeItem('pickupPayloadContext');
      localStorage.removeItem('shippingDocsContext');
      localStorage.removeItem('selectedServiceContext');
      localStorage.removeItem('selectedPlanningLaneContext');
      localStorage.removeItem('selectedAccountContext');
      localStorage.removeItem('selectedJobContext');
      localStorage.removeItem('selectedManualLegsContext');
      localStorage.removeItem('brokerFormDataContext');
      localStorage.removeItem('isMetricContext');
      localStorage.removeItem('savedQuoteFormDataContext');
      localStorage.removeItem('addLegShipmentDataContext');
      localStorage.removeItem('addLegShipmentPackagesContext');
      localStorage.removeItem('allCommoditiesContext');
      localStorage.removeItem('multiLegListContext');
      localStorage.removeItem('totalLegsContext');
      localStorage.removeItem('selectedMultiLegRateContext');
      localStorage.removeItem('ratesMultiLegApiDataContext');
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  return (
    <ShipFormContext.Provider
      value={{
        setSelectedATALegsInfo,
        setOriginFormData,
        setDestinationFormData,
        setShipperFormData,
        setConsigneeFormData,
        setCarrierOptionsContext,
        setRouteValidationsContext,
        setRatesApiDataContext,
        setRatesApiPayloadContext,
        setReferenceFormDataContext,
        setSpecialInstructionContext,
        setPickupValidateDataContext,
        setPickupTimezoneDataContext,
        setSelectedRateContext,
        setFinalRateContext,
        setPickupPayloadContext,
        setShippingDocsContext,
        setSelectedServiceContext,
        setSelectedPlanningLaneContext,
        setSelectedAccountContext,
        setSelectedJobContext,
        setSelectedManualLegsContext,
        setBrokerFormDataContext,
        setIsMetricContext,
        setSavedQuoteFormDataContext,
        setAddLegShipmentDataContext,
        setAddLegShipmentPackagesContext,
        setAllCommoditiesContext,
        setMultiLegListContext,
        setTotalLegsContext,
        setSelectedMultiLegRateContext,
        setRatesMultiLegApiDataContext,
      }}
    >
      {children}
    </ShipFormContext.Provider>
  );
}

export const useShipForm = () => {
  const context = useContext(ShipFormContext);
  if (context === undefined) {
    throw new Error('useShipForm must be used within a ShipFormProvider');
  }

  const getOriginFormData = () => {
    const originFormDataString = localStorage.getItem('originFormData');
    if (originFormDataString) {
      return JSON.parse(originFormDataString);
    }
    return null;
  };

  const getSelectedATALegsInfo = () => {
    const selectedATALegsInfoString = localStorage.getItem(
      'selectedATALegsInfo'
    );
    if (selectedATALegsInfoString) {
      return JSON.parse(selectedATALegsInfoString);
    }
    return null;
  };

  const getDestinationFormData = () => {
    const destinationFormDataString = localStorage.getItem(
      'destinationFormData'
    );
    if (destinationFormDataString) {
      return JSON.parse(destinationFormDataString);
    }
    return null;
  };
  const getShipperFormData = () => {
    const shipperFormDataString = localStorage.getItem('shipperFormData');
    if (shipperFormDataString) {
      return JSON.parse(shipperFormDataString);
    }
    return null;
  };
  const getConsigneeFormData = () => {
    const consigneeFormDataString = localStorage.getItem('consigneeFormData');
    if (consigneeFormDataString) {
      return JSON.parse(consigneeFormDataString);
    }
    return null;
  };
  const getSelectedCarrierContext = () => {
    const carrierOptionsString = localStorage.getItem('carrierOptionsContext');
    if (carrierOptionsString) {
      return JSON.parse(carrierOptionsString);
    }
    return null;
  };
  const getRouteValidationsContext = () => {
    const routeValidationsContextString = localStorage.getItem(
      'routeFormValidationContext'
    );
    if (routeValidationsContextString) {
      return JSON.parse(routeValidationsContextString);
    }
    return null;
  };
  const getRatesApiDataContext = () => {
    const ratesApiDataContextString = localStorage.getItem(
      'ratesApiDataContext'
    );
    if (ratesApiDataContextString) {
      return JSON.parse(ratesApiDataContextString);
    }
    return null;
  };
  const getRatesApiPayloadContext = () => {
    const ratesApiPayloadContextString = localStorage.getItem(
      'ratesApiPayloadContext'
    );
    if (ratesApiPayloadContextString) {
      return JSON.parse(ratesApiPayloadContextString);
    }
    return null;
  };
  const getPickupValidateDataContext = () => {
    const pickupValidateDataContextString = localStorage.getItem(
      'pickupValidateDataContext'
    );
    if (pickupValidateDataContextString) {
      return JSON.parse(pickupValidateDataContextString);
    }
    return null;
  };
  const getPickupTimezoneDataContext = () => {
    const pickupTimezoneDataContextString = localStorage.getItem(
      'pickupTimezoneDataContext'
    );
    if (pickupTimezoneDataContextString) {
      return JSON.parse(pickupTimezoneDataContextString);
    }
    return null;
  };
  const getSelectedRateContext = () => {
    const selectedRateContextString = localStorage.getItem(
      'selectedRateContext'
    );
    if (selectedRateContextString) {
      return JSON.parse(selectedRateContextString);
    }
    return null;
  };
  const getReferenceFormDataContext = () => {
    const referenceFormDataContextString = localStorage.getItem(
      'referenceFormDataContext'
    );
    if (referenceFormDataContextString) {
      return JSON.parse(referenceFormDataContextString);
    }
    return null;
  };
  const getSpecialInstructionContext = () => {
    const specialInstructionContextString = localStorage.getItem(
      'specialInstructionContext'
    );
    if (specialInstructionContextString) {
      return JSON.parse(specialInstructionContextString);
    }
    return null;
  };
  const getFinalRateContext = () => {
    const finalRateContextString = localStorage.getItem('finalRateContext');
    if (finalRateContextString) {
      return JSON.parse(finalRateContextString);
    }
    return null;
  };
  const getPickupPayloadContext = () => {
    const pickupPayloadContextString = localStorage.getItem(
      'pickupPayloadContext'
    );
    if (pickupPayloadContextString) {
      return JSON.parse(pickupPayloadContextString);
    }
    return null;
  };
  const getShippingDocsContext = () => {
    const shippingDocsContextString = localStorage.getItem(
      'shippingDocsContext'
    );
    if (shippingDocsContextString) {
      return JSON.parse(shippingDocsContextString);
    }
    return null;
  };

  const getSelectedServiceContext = () => {
    const selectedServiceContextString = localStorage.getItem(
      'selectedServiceContext'
    );
    if (selectedServiceContextString) {
      return JSON.parse(selectedServiceContextString);
    }
    return null;
  };
  const getSelectedPlanningLaneContext = () => {
    const selectedPlanningLaneContextString = localStorage.getItem(
      'selectedPlanningLaneContext'
    );
    if (selectedPlanningLaneContextString) {
      return JSON.parse(selectedPlanningLaneContextString);
    }
    return null;
  };

  const getSelectedAccountContext = () => {
    const selectedAccountContextString = localStorage.getItem(
      'selectedAccountContext'
    );
    if (
      selectedAccountContextString &&
      selectedAccountContextString !== undefined &&
      selectedAccountContextString !== 'undefined'
    ) {
      return JSON.parse(selectedAccountContextString);
    }
    return null;
  };

  const getSelectedJobContext = () => {
    const selectedJobContextString = localStorage.getItem('selectedJobContext');
    if (selectedJobContextString) {
      return JSON.parse(selectedJobContextString);
    }
    return null;
  };

  const getSelectedManualLegsContext = () => {
    const selectedManualLegsContextString = localStorage.getItem(
      'selectedManualLegsContext'
    );
    if (selectedManualLegsContextString) {
      return JSON.parse(selectedManualLegsContextString);
    }
    return null;
  };

  const getBrokerFormDataContext = () => {
    const brokerFormDataContextString = localStorage.getItem(
      'brokerFormDataContext'
    );
    if (brokerFormDataContextString) {
      return JSON.parse(brokerFormDataContextString);
    }
    return null;
  };

  const getIsMetricContext = () => {
    const isMetricContextString = localStorage.getItem('isMetricContext');
    if (isMetricContextString) {
      return JSON.parse(isMetricContextString);
    }
    return null;
  };

  const getSavedQuoteFormDataContext = () => {
    const savedQuoteFormDataContextString = localStorage.getItem(
      'savedQuoteFormDataContext'
    );
    if (savedQuoteFormDataContextString) {
      return JSON.parse(savedQuoteFormDataContextString);
    }
    return null;
  };

  const getAddLegShipmentDataContext = () => {
    const addLegShipmentDataContextString = localStorage.getItem(
      'addLegShipmentDataContext'
    );
    if (addLegShipmentDataContextString) {
      return JSON.parse(addLegShipmentDataContextString);
    }
    return null;
  };

  const getAddLegShipmentPackagesContext = () => {
    const addLegShipmentPackagesContextString = localStorage.getItem(
      'addLegShipmentPackagesContext'
    );
    if (addLegShipmentPackagesContextString) {
      return JSON.parse(addLegShipmentPackagesContextString);
    }
    return null;
  };

  const getAllCommoditiesContext = () => {
    const allCommoditiesContextString = localStorage.getItem(
      'allCommoditiesContext'
    );
    if (allCommoditiesContextString) {
      return JSON.parse(allCommoditiesContextString);
    }
    return null;
  };
  const getTotalLegs = () => {
    const totalLegsContext = localStorage.getItem('totalLegsContext');
    if (totalLegsContext) {
      return JSON.parse(totalLegsContext);
    }
    return null;
  };

  const getMultiLegListContext = () => {
    const multiLegListContextString = localStorage.getItem(
      'multiLegListContext'
    );
    if (multiLegListContextString) {
      return JSON.parse(multiLegListContextString);
    }
    return null;
  };
  const getSelectedMultiLegRateContext = () => {
    const selectedMultiLegRateContextString = localStorage.getItem(
      'selectedMultiLegRateContext'
    );
    if (selectedMultiLegRateContextString) {
      return JSON.parse(selectedMultiLegRateContextString);
    }
    return null;
  };
  const getRatesMultilegApiDataContext = () => {
    const ratesMultilegApiDataContextString = localStorage.getItem(
      'ratesMultiLegApiDataContext'
    );
    if (ratesMultilegApiDataContextString) {
      return JSON.parse(ratesMultilegApiDataContextString);
    }
    return null;
  };
  return {
    ...context,
    getOriginFormData,
    getSelectedATALegsInfo,
    getDestinationFormData,
    getShipperFormData,
    getConsigneeFormData,
    getSelectedCarrierContext,
    getRouteValidationsContext,
    getRatesApiDataContext,
    getRatesApiPayloadContext,
    getPickupValidateDataContext,
    getPickupTimezoneDataContext,
    getSelectedRateContext,
    getReferenceFormDataContext,
    getSpecialInstructionContext,
    getFinalRateContext,
    getPickupPayloadContext,
    getShippingDocsContext,
    getSelectedServiceContext,
    getSelectedPlanningLaneContext,
    getSelectedAccountContext,
    getSelectedJobContext,
    getSelectedManualLegsContext,
    getBrokerFormDataContext,
    getIsMetricContext,
    getSavedQuoteFormDataContext,
    getAddLegShipmentDataContext,
    getAddLegShipmentPackagesContext,
    getAllCommoditiesContext,
    getMultiLegListContext,
    getTotalLegs,
    getSelectedMultiLegRateContext,
    getRatesMultilegApiDataContext,
  };
};
